"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseActivityIdsCsv = parseActivityIdsCsv;
exports.collectActivityIdsCsv = collectActivityIdsCsv;
exports.collectActivityRedoResetIds = collectActivityRedoResetIds;
exports.collectActivityRedoResetIdsCsv = collectActivityRedoResetIdsCsv;
exports.hasIncompleteActivitiesForCharacter = hasIncompleteActivitiesForCharacter;
exports.generateIncompleteActivityListForCharacter = generateIncompleteActivityListForCharacter;
const characterActivityState_1 = require("./characterActivityState");
const evaluateActivityPlayable_1 = require("./evaluateActivityPlayable");
const activitySceneHelpers_1 = require("./activitySceneHelpers");
function parseActivityIdsCsv(activityIdsCsv) {
    return (activityIdsCsv ?? '')
        .toString()
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
}
/**
 * Builds a comma-separated list of activity ids from adventure definitions using optional filters.
 */
function collectActivityIdsCsv(activities, options = {}) {
    const filtered = activities.filter((def) => (0, activitySceneHelpers_1.matchesActivityGroupFilter)(def, options));
    const sorted = options.sort !== undefined
        ? (0, activitySceneHelpers_1.sortActivitiesForGroup)(filtered, options.sort === 'name' ? 'name' : 'list_order')
        : filtered;
    return sorted.map((def) => def.id).join(',');
}
/**
 * Activity ids to clear when redoing {@code rootActivityIds}: the roots plus any activity
 * that directly or indirectly lists one of them as {@link ActivityDefinition.parentActivityId}
 * or in {@link ActivityDefinition.requiresActive}.
 */
function collectActivityRedoResetIds(activities, rootActivityIds) {
    const idSet = new Set(rootActivityIds.map((id) => id.trim()).filter(Boolean));
    if (idSet.size === 0 || activities.length === 0) {
        return [...idSet];
    }
    let changed = true;
    while (changed) {
        changed = false;
        for (const def of activities) {
            const activityId = (def.id ?? '').trim();
            if (!activityId || idSet.has(activityId)) {
                continue;
            }
            const parent = (def.parentActivityId ?? '').trim();
            if (parent && idSet.has(parent)) {
                idSet.add(activityId);
                changed = true;
                continue;
            }
            for (const req of def.requiresActive ?? []) {
                if (idSet.has((req ?? '').trim())) {
                    idSet.add(activityId);
                    changed = true;
                    break;
                }
            }
        }
    }
    return [...idSet];
}
function collectActivityRedoResetIdsCsv(activities, rootActivityIds) {
    return collectActivityRedoResetIds(activities, rootActivityIds).join(',');
}
function hasIncompleteActivitiesForCharacter(activityIdsCsv, characterName, getDef, getVariable, evaluateRequiresScript) {
    const ids = parseActivityIdsCsv(activityIdsCsv);
    if (ids.length === 0) {
        return false;
    }
    const state = (0, characterActivityState_1.readActivitySetsFromVariableValues)(getVariable);
    for (const id of ids) {
        const def = getDef(id);
        if (!def) {
            continue;
        }
        if (!(0, evaluateActivityPlayable_1.evaluateActivityVisibleForCharacter)(def, characterName)) {
            continue;
        }
        if (def.requiresScript && def.requiresScript.trim()) {
            if (!evaluateRequiresScript(def.requiresScript)) {
                continue;
            }
        }
        if (!state.completed.has(id)) {
            return true;
        }
    }
    return false;
}
function generateIncompleteActivityListForCharacter(activityIdsCsv, characterName, getDef, getVariable, evaluateRequiresScript) {
    const ids = parseActivityIdsCsv(activityIdsCsv);
    if (ids.length === 0) {
        return '';
    }
    const state = (0, characterActivityState_1.readActivitySetsFromVariableValues)(getVariable);
    const lines = [];
    for (const id of ids) {
        const def = getDef(id);
        if (!def) {
            continue;
        }
        if (!(0, evaluateActivityPlayable_1.evaluateActivityVisibleForCharacter)(def, characterName)) {
            continue;
        }
        if (def.requiresScript && def.requiresScript.trim()) {
            if (!evaluateRequiresScript(def.requiresScript)) {
                continue;
            }
        }
        if (state.completed.has(id)) {
            continue;
        }
        const name = def.name?.trim() || id;
        lines.push(`- ${name}`);
    }
    return lines.join('\n');
}
//# sourceMappingURL=incompleteActivityChecks.js.map